import React from "react";
import { Link } from "react-router-dom";

const Loginlayout = ({
  Banner,
  Login,
  Mobile_No_Handler,
  Otp_Handler,
  Change_NumberHandler,
  Resend_Otp_Handler,
  LoginHandler,
  Verify_OTP_handler,
  ResendCount,
}) => {
  const KeypressHandler = (e) => {
    if (e.keyCode == 13) {
      LoginHandler();
    }
  };
  const Otp_KeypressHandler = (e) => {
    if (e.keyCode == 13) {
      Verify_OTP_handler();
    }
  };
  return (
    <div className="login-container flex justify-center items-center h-full">
      <div className="login-left w-6/12 h-full flex justify-center items-center max-[640px]:hidden">
        <img src={Banner} alt="" className="w-full" draggable={false} />
      </div>
      <div className="login-right w-6/12 h-full flex justify-center items-center max-[640px]:w-full">
        <div className="login-input w-full flex justify-center items-center flex-col">
          <h2 className="text-2xl font-semibold py-2">Welcome</h2>
          <p className="text-sm font-medium text-slate-400">
            Login to teacher portal
          </p>

          <input
            type="number"
            className="border border-slate-300 border-solid outline-none p-2 w-11/12 max-w-xs my-2 max-[440px]:py-4"
            placeholder="Mobile number"
            value={Login.number}
            maxLength={10}
            onInput={Mobile_No_Handler}
            onKeyDown={KeypressHandler}
          />
          {Login.opt_send && (
            <input
              type="number"
              className="border border-slate-300 border-solid outline-none p-2 w-11/12 max-w-xs my-2 max-[440px]:py-4"
              placeholder="Enter otp"
              value={Login.otp}
              onInput={Otp_Handler}
              onKeyDown={Otp_KeypressHandler}
            />
          )}

          {Login.opt_send && (
            <div
              className={`w-6/12 flex justify-between items-center mt-5 max-[440px]:w-9/12 `}
            >
              <button
                className="underline text-blue-600"
                onClick={Change_NumberHandler}
              >
                Change number
              </button>
              <button
                className={`underline text-blue-600 ${
                  ResendCount == 0
                    ? "pointer-events-auto opacity-100"
                    : "pointer-events-none opacity-50"
                }`}
                onClick={Resend_Otp_Handler}
              >
                {ResendCount == 0
                  ? "Resend otp"
                  : `Resend otp in ${ResendCount}`}
              </button>
            </div>
          )}
          {!Login.opt_send && (
            <button
              className="bg-sky-500 text-white text-sm font-semibold py-2 px-6 mt-5 rounded max-[440px]:py-3 max-[440px]:text-1xl max-[440px]:px-10 "
              onClick={LoginHandler}
            >
              Submit
            </button>
          )}
          {Login.opt_send && (
            <button
              className="bg-sky-500 text-white text-sm font-semibold py-2 px-6 mt-5 rounded max-[440px]:py-3 max-[440px]:text-1xl max-[440px]:px-10 "
              onClick={Verify_OTP_handler}
            >
              Verify OTP
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Loginlayout;
